export default __webpack_public_path__ + "static/media/Icon=Stocks.70129188.svg";